import { getText } from '../internal/TextLabels'

export const ActionTypes = Object.freeze({
  DEBIT: 'debit',
  CREDIT: 'credit',
  CREDIT_AMOUNT: 'credit-amount',
  CREDIT_TRANSACTION_AMOUNT: 'credit-transaction-amount',
  ANNUL: 'annul',
})

export const TransactionTypes = Object.freeze({
  CREATE: 'CREATE',
  DEBIT: 'DEBIT',
  CREDIT: 'CREDIT',
  ANNUL: 'ANNUL',
  MODIFY_CART: 'MODIFY_CART',
})

export const TransactionStatus = Object.freeze({
  FROZEN: 'FROZEN',
  ANNULLED: 'ANNULLED',
  SIGNING_REQUIRED: 'SIGNING_REQUIRED',
  CUSTOMER_INTERACTION_REQUIRED: 'CUSTOMER_INTERACTION_REQUIRED',
})

export const TransactionResultTypes = Object.freeze({
  RESERVED_TRANSACTION: 'RESERVED_TRANSACTION',
  BOOKED_TRANSACTION: 'BOOKED_TRANSACTION',
  PAYMENT: 'PAYMENT',
})

export const TransactionSearchFields = Object.freeze({
  PAYMENT_ACTION_STATUS: 'PAYMENT_ACTION_STATUS',
  PAYMENT_STATUS: 'PAYMENT_STATUS',
  STATUS: 'STATUS',
  CHANNEL_TYPE: 'CHANNEL_TYPE',
  STORE_STORE_ID: 'STORE_STORE_ID',
})

export const TransactionSearchTypes = Object.freeze({
  MUST: 'MUST',
  MUST_NOT: 'MUST_NOT',
  SHOULD: 'SHOULD',
})

export const TransactionSearchValues = Object.freeze({
  ANNULLED: 'ANNULLED',
  FROZEN: 'FROZEN',
  CREDITABLE: 'creditable',
  CREDITED: 'credited',
  DEBITABLE: 'debitable',
  DEBITED: 'debited',
  PARTLY_CREDITED: 'PARTLY_CREDITED',
  PARTLY_DEBITED: 'PARTLY_DEBITED',
  ECOMMERCE: 'ECOMMERCE',
  UPGRADED: 'UPGRADED',
  MERCHANT_API: 'MERCHANT_API',
})

export const TransactionSelectFilterTypes = Object.freeze({
  ALL: 'all',
  ANNULLED: 'annulled',
  CREDITABLE: 'creditable',
  CREDITED: 'credited',
  DEBIT: 'debit',
  DEBITED: 'debited',
  FROZEN: 'frozen',
  PARTLY_CREDITED: 'partlyCredited',
  PARTLY_DEBITED: 'partlyDebited',
  ECOMMERCE: 'eCommerce',
  MERCHANT_PORTAL: 'merchantPortal',
  MERCHANT_API: 'merchantApi',
})

export const PaymentMethodFallbackIds = Object.freeze({
  ONE_TIME_ACCOUNT: '00000000-0000-0000-0000-000000000001',
  CARD_ACCOUNT: '00000000-0000-0000-0000-000000000002',
  REVOLVING_ACCOUNT: '00000000-0000-0000-0000-000000000003',
})

export const PaymentMethodDescriptions = Object.freeze({
  [PaymentMethodFallbackIds.ONE_TIME_ACCOUNT]: getText(
    'payApply.paymentMethods.oneTimeAccount',
  ),
  [PaymentMethodFallbackIds.CARD_ACCOUNT]: getText(
    'payApply.paymentMethods.cardAccount',
  ),
  [PaymentMethodFallbackIds.REVOLVING_ACCOUNT]: getText(
    'payApply.paymentMethods.revolvingAccount',
  ),
})
